/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Ad_Trim_Failed_ToastInputs */

const en_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trim to audio duration failed with message: ${i?.error}`)
};

const fr_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'ajustement a la duree audio : ${i?.error}`)
};

const de_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Kürzen auf die Audiodauer ist fehlgeschlagen. Fehlermeldung: ${i?.error}`)
};

const it_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il taglio alla durata audio non è riuscito con il messaggio: ${i?.error}`)
};

const ru_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обрезать аудиодорожку до нужной длительности с сообщением: ${i?.error}`)
};

const es_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al ajustar la duración del audio con el mensaje: ${i?.error}`)
};

const zh_cn2_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频时长裁剪失败，错误信息：${i?.error}`)
};

const ja_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオの長さに合わせてトリミングできませんでした。メッセージ: ${i?.error}`)
};

const hi_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो अवधि के अनुसार ट्रिम करने में विफलता मिली, संदेश: ${i?.error}`)
};

const pt_pt2_shortcut_keys_ad_trim_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A tentativa de ajustar a duração do áudio falhou com a mensagem: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Trim to audio duration failed with message: {error}" |
*
* @param {Shortcut_Keys_Ad_Trim_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_trim_failed_toast = /** @type {((inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Trim_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "de") return de_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "it") return it_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "es") return es_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_ad_trim_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_ad_trim_failed_toast(inputs)
	return en_shortcut_keys_ad_trim_failed_toast(inputs)
});